import type { Zone } from '../types/zone';

const ZONE_STORAGE_KEY = 'growing-zone';

export function getStoredZone(): Zone | null {
  // Try session storage first
  const sessionZone = sessionStorage.getItem(ZONE_STORAGE_KEY);
  if (sessionZone) {
    return sessionZone as Zone;
  }

  // Fall back to local storage
  const localZone = localStorage.getItem(ZONE_STORAGE_KEY);
  if (localZone) {
    // Store in session for future use
    sessionStorage.setItem(ZONE_STORAGE_KEY, localZone);
    return localZone as Zone;
  }

  return null;
}

export function storeZone(zone: Zone | null): void {
  if (zone === null) {
    sessionStorage.removeItem(ZONE_STORAGE_KEY);
    localStorage.removeItem(ZONE_STORAGE_KEY);
  } else {
    sessionStorage.setItem(ZONE_STORAGE_KEY, zone);
    localStorage.setItem(ZONE_STORAGE_KEY, zone);
  }
}